export const ERROR_CODES = {
  PROCESSING_EMAIL_ENRICHMENT: 4001006, // happens when: simultaneously processing email enrichment limit reached
  SEARCH_FILTER_SINGLE_LIMIT: 4001010, // single filter size exceeds limit 300 [the number may change]
  SEARCH_FILTER_GENERAL_LIMIT: 4001008, // request size must less or equal to 51,200 bytes. [the number may change]
  KEYWORDS_FILTER_SOURCES_LIMIT: 4001015, // Keywords filter sources exceed the max allowed (5 items) [the number may change]
  ENRICHMENT_WRONG_MAPPING: 4001007, // wrong columns sent to enrichment API
};
